// // ContactUs.jsx
// import React, { useState } from "react";

// export default function Contactus() {
//   const [form, setForm] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     message: "",
//   });
//   const [popup, setPopup] = useState(null);

//   // ✅ Replace with your WhatsApp number (country code, no + or spaces)
//   const whatsappNumber = "917611100056";

//   // simple mobile detection
//   const isMobileDevice = () =>
//     typeof navigator !== "undefined" &&
//     /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
//       navigator.userAgent
//     );

//   const showPopup = (type, text, ms = 2200) => {
//     setPopup({ type, text });
//     setTimeout(() => setPopup(null), ms);
//   };

//   const handleSubmit = (e) => {
//     e && e.preventDefault();

//     if (!form.name.trim() || !form.email.trim() || !form.message.trim()) {
//       showPopup("error", "Please fill all required fields ❌");
//       return;
//     }

//     // build message
//     const text = `🌟 *New Contact Message* 🌟
// -----------------------
// 👤 Name: ${form.name}
// 📧 Email: ${form.email}
// 📞 Phone: ${form.phone || "N/A"}
// 💬 Message: ${form.message}
// -----------------------
// Sent from RefreshH2O Contact Form`;

//     const encoded = encodeURIComponent(text);

//     // choose URL depending on device
//     let url;
//     if (isMobileDevice()) {
//       // On most mobiles this opens the WhatsApp app.
//       // Fallback to api.whatsapp.com which also works but whatsapp:// is more likely to open app.
//       // Some Android browsers might block whatsapp:// — api.whatsapp.com still works.
//       url = `whatsapp://send?phone=${whatsappNumber}&text=${encoded}`;
//     } else {
//       // Desktop: open WhatsApp Web in a new tab
//       url = `https://web.whatsapp.com/send?phone=${whatsappNumber}&text=${encoded}`;
//     }

//     // Try opening. For mobile we first try whatsapp:// then fallback to api.whatsapp.com if needed.
//     if (isMobileDevice()) {
//       // try app protocol, then fallback
//       window.location.href = url;
//       // also show popup (user feedback)
//       showPopup("success", "Opening WhatsApp app 💬...");
//     } else {
//       // desktop open in new tab
//       window.open(url, "_blank");
//       showPopup("success", "Opening WhatsApp Web 💬...");
//     }

//     // reset form
//     setForm({ name: "", email: "", phone: "", message: "" });
//   };

//   return (
//     <>
//       <style>{`
//         .contact-container {
//           min-height: 80vh;
//           display: flex;
//           justify-content: center;
//           align-items: center;
//           background: linear-gradient(120deg, #03b8b3, #04d4cd);
//           padding: 30px 20px;
//         }
//         .contact-box {
//           background: rgba(255,255,255,0.94);
//           backdrop-filter: blur(8px);
//           padding: 30px;
//           border-radius: 14px;
//           width: 100%;
//           max-width: 520px;
//           box-shadow: 0 10px 28px rgba(0,0,0,0.12);
//           animation: pop .25s ease;
//         }
//         @keyframes pop { from { opacity:0; transform:scale(.98); } to { opacity:1; transform:scale(1); } }
//         .contact-title { text-align:center; font-size:26px; font-weight:800; color:#022c32; margin-bottom:14px; }
//         .contact-input { width:90%; padding:12px; border-radius:10px; border:1px solid #bcd6db; margin-bottom:12px; font-size:15px; outline:none; }
//         .contact-input:focus { border-color:#03b8b3; box-shadow:0 0 6px rgba(3,184,179,0.25); background:#fff; }
//         .contact-btn { width:95%; padding:12px; border:none; border-radius:10px; background: linear-gradient(120deg,#03b8b3,#04d4cd); color:#fff; font-size:16px; font-weight:700; cursor:pointer; }
//         .contact-btn:hover { transform: translateY(-2px); box-shadow:0 6px 16px rgba(0,0,0,0.12); }
//         .popup { position: fixed; top: 18px; right: 18px; background: #fff; padding: 12px 14px; border-radius: 10px; box-shadow: 0 8px 20px rgba(0,0,0,0.18); font-weight:600; z-index:999; }
//         .popup.success { border-left: 6px solid #03b8b3; color:#022c32; }
//         .popup.error { border-left: 6px solid #e53935; color:#8a1f2d; }
//         @media (max-width:600px) {
//           .contact-box { padding: 18px; margin: 12px; }
//           .contact-title { font-size:20px; }
//         }
//       `}</style>

//       <div className="contact-container">
//         <form className="contact-box" onSubmit={handleSubmit}>
//           <div className="contact-title">📞 Contact Us</div>

//           <input
//             type="text"
//             placeholder="Your Name *"
//             className="contact-input"
//             value={form.name}
//             onChange={(e) => setForm({ ...form, name: e.target.value })}
//             required
//           />
//           <input
//             type="email"
//             placeholder="Your Email *"
//             className="contact-input"
//             value={form.email}
//             onChange={(e) => setForm({ ...form, email: e.target.value })}
//             required
//           />
//           <input
//             type="text"
//             placeholder="Your Phone (Optional)"
//             className="contact-input"
//             value={form.phone}
//             onChange={(e) => setForm({ ...form, phone: e.target.value })}
//           />
//           <textarea
//             placeholder="Your Message *"
//             className="contact-input"
//             rows="4"
//             value={form.message}
//             onChange={(e) => setForm({ ...form, message: e.target.value })}
//             required
//           />

//           <button type="submit" className="contact-btn">
//             Send via WhatsApp 💬
//           </button>
//         </form>

//         {popup && (
//           <div
//             className={`popup ${
//               popup.type === "success" ? "success" : "error"
//             }`}
//           >
//             {popup.text}
//           </div>
//         )}
//       </div>
//     </>
//   );
// }


// ContactUs.jsx
import React, { useState } from "react";

export default function Contactus() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [popup, setPopup] = useState(null);

  // ✅ Replace with your WhatsApp number (country code, no + or spaces)
  const whatsappNumber = "919926202603";

  // simple mobile detection
  const isMobileDevice = () =>
    typeof navigator !== "undefined" &&
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );

  const showPopup = (type, text, ms = 2200) => {
    setPopup({ type, text });
    setTimeout(() => setPopup(null), ms);
  };

  const handleSubmit = (e) => {
    e && e.preventDefault();

    if (!form.name.trim() || !form.email.trim() || !form.message.trim()) {
      showPopup("error", "Please fill all required fields ❌");
      return;
    }

    // build message
    const text = `🌟 *New Contact Message* 🌟
-----------------------
👤 Name: ${form.name}
📧 Email: ${form.email}
📞 Phone: ${form.phone || "N/A"}
💬 Message: ${form.message}
-----------------------
Sent from RefreshH2O Contact Form`;

    const encoded = encodeURIComponent(text);

    // choose URL depending on device
    let url;
    if (isMobileDevice()) {
      // On most mobiles this opens the WhatsApp app.
      // Fallback to api.whatsapp.com which also works but whatsapp:// is more likely to open app.
      // Some Android browsers might block whatsapp:// — api.whatsapp.com still works.
      url = `whatsapp://send?phone=${whatsappNumber}&text=${encoded}`;
    } else {
      // Desktop: open WhatsApp Web in a new tab
      url = `https://web.whatsapp.com/send?phone=${whatsappNumber}&text=${encoded}`;
    }

    // Try opening. For mobile we first try whatsapp:// then fallback to api.whatsapp.com if needed.
    if (isMobileDevice()) {
      // try app protocol, then fallback
      window.location.href = url;
      // also show popup (user feedback)
      showPopup("success", "Opening WhatsApp app 💬...");
    } else {
      // desktop open in new tab
      window.open(url, "_blank");
      showPopup("success", "Opening WhatsApp Web 💬...");
    }

    // reset form
    setForm({ name: "", email: "", phone: "", message: "" });
  };

  return (
    <>
      <style>{`
        .contact-container {
          min-height: 80vh;
          display: flex;
          justify-content: center;
          align-items: center;
          background: linear-gradient(120deg, #03b8b3, #04d4cd);
          padding: 30px 20px;
        }
        .contact-box {
          background: rgba(255,255,255,0.94);
          backdrop-filter: blur(8px);
          padding: 30px;
          border-radius: 14px;
          width: 100%;
          max-width: 550px;
          box-shadow: 0 10px 28px rgba(0,0,0,0.12);
          animation: pop .25s ease;
        }
        @keyframes pop { from { opacity:0; transform:scale(.98); } to { opacity:1; transform:scale(1); } }
        .contact-title { text-align:center; font-size:26px; font-weight:800; color:#022c32; margin-bottom:14px; }
        .contact-input { width:100%; box-sizing: border-box; padding:12px; border-radius:10px; border:1px solid #bcd6db; margin-bottom:12px; font-size:15px; outline:none; }
        .contact-input:focus { border-color:#03b8b3; box-shadow:0 0 6px rgba(3,184,179,0.25); background:#fff; }
        .contact-btn { width:100%; padding:12px; border:none; border-radius:10px; background: linear-gradient(120deg,#03b8b3,#04d4cd); color:#fff; font-size:16px; font-weight:700; cursor:pointer; }
        .contact-btn:hover { transform: translateY(-2px); box-shadow:0 6px 16px rgba(0,0,0,0.12); }
        .popup { position: fixed; top: 18px; right: 18px; background: #fff; padding: 12px 14px; border-radius: 10px; box-shadow: 0 8px 20px rgba(0,0,0,0.18); font-weight:600; z-index:999; }
        .popup.success { border-left: 6px solid #03b8b3; color:#022c32; }
        .popup.error { border-left: 6px solid #e53935; color:#8a1f2d; }
        @media (max-width:600px) {
          // .contact-box { padding: 18px; margin: 12px; }
          .contact-title { font-size:20px; }
        }
      `}</style>

      <div className="contact-container">
        <form className="contact-box" onSubmit={handleSubmit}>
          <div className="contact-title">📞 Contact Us</div>

          <input
            type="text"
            placeholder="Your Name *"
            className="contact-input"
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            required
          />
          <input
            type="email"
            placeholder="Your Email *"
            className="contact-input"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            required
          />
          <input
            type="text"
            placeholder="Your Phone (Optional)"
            className="contact-input"
            value={form.phone}
            onChange={(e) => setForm({ ...form, phone: e.target.value })}
          />
          <textarea
            placeholder="Your Message *"
            className="contact-input"
            rows="4"
            value={form.message}
            onChange={(e) => setForm({ ...form, message: e.target.value })}
            required
          />

          <button type="submit" className="contact-btn">
            Send via WhatsApp 💬
          </button>
        </form>

        {popup && (
          <div
            className={`popup ${
              popup.type === "success" ? "success" : "error"
            }`}
          >
            {popup.text}
          </div>
        )}
      </div>
    </>
  );
}